import React, { useState } from 'react';

function PdfAnalysis({ token }) {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setError(null);
    };

    const handleUpload = async () => {
        if (!file) {
            setError('Please select a file first.');
            return;
        }

        setLoading(true);
        setError(null);
        setResult(null);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch('/api/pdf/analyze', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to analyze PDF');
            }

            const data = await response.json();
            setResult(data);
        } catch (err) {
            console.error('Error analyzing PDF:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card shadow-sm mt-4">
            <div className="card-body">
                <h3 className="card-title">PDF Analysis</h3>
                <div className="mb-3">
                    <input 
                        type="file" 
                        className="form-control" 
                        accept=".pdf" 
                        onChange={handleFileChange} 
                    />
                </div>
                <button 
                    onClick={handleUpload} 
                    className="btn btn-primary" 
                    disabled={loading || !file}
                >
                    {loading ? 'Analyzing...' : 'Analyze PDF'}
                </button>

                {error && (
                    <div className="alert alert-danger mt-3">
                        {error}
                    </div>
                )}

                {result && (
                    <div className="mt-4 text-start">
                        <h5>Analysis Result:</h5>
                        <pre className="bg-gradient p-3 border rounded">
                            <code>{JSON.stringify(result, null, 2)}</code>
                        </pre>
                    </div>
                )}
            </div>
        </div>
    );
}

export default PdfAnalysis;
